import { createStore } from 'vuex';
import createPersistedstate from 'vuex-persistedstate';
import app from './module/app';
import options from './module/options';
import botView from './module/botView';
import shareWeb from './module/shareBot';
import botSetting from './module/botSetting';
import flow from './module/flow';
import aiWrite from './module/aiWrite';
import multiAgent from './module/multiAgent';

const store = createStore({
  modules: {
    app,
    options,
    botView,
    shareWeb,
    botSetting,
    flow,
    aiWrite,
    multiAgent
  },
  plugins: [
    createPersistedstate({
      paths: ['app', 'aiWrite']
    })
  ]
});

export default store;
